import { useMemo, useState } from 'react';
import useQueryParams from './useQueryParams';
import { useGetVessel } from './queries/useGetVessel';
import { type MmsiKey, type TargetVessel, type TargetVesselHandler, type VesselViewModel } from '../types';

export const useTargetVessel = (vesselData: Record<MmsiKey, VesselViewModel>): TargetVesselHandler => {
  const { mmsi } = useQueryParams();
  const [isLockedOnTarget, setIsLockedOnTarget] = useState(!!mmsi);
  const [targetVesselMmsi, setTargetVesselMmsi] = useState(mmsi);
  const vessel = useGetVessel(mmsi, !vesselData[targetVesselMmsi]);

  const targetVessel = useMemo((): TargetVessel => {
    if (!targetVesselMmsi) {
      return { mmsi: null, isLockedOnTarget: null } as TargetVessel;
    }

    const newTargetVessel = vesselData[targetVesselMmsi] ?? vessel;
    if (newTargetVessel) {
      return { ...newTargetVessel, isLockedOnTarget };
    }
    return { mmsi: targetVesselMmsi, isLockedOnTarget } as TargetVessel;
  }, [vesselData, targetVesselMmsi, isLockedOnTarget, vessel]);

  return { targetVessel, setTargetVesselMmsi, setIsLockedOnTarget };
};
